import {
  CloseButton,
  DELETE_WARNING,
  DropDownMenu,
  MenuItemType,
  
  Typography,
  newToast,
  Stack,
  ListContextValue,
  ListContext,
} from "@compass/core";
import "moment-timezone";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";

export const DataCenterFilePageHeader = (props: { id: number; canDelete: boolean; onDelete: () => void }) => {
  const listContext = useContext<ListContextValue>(ListContext);
  const dispatch = useDispatch();

  const postDelete = (id: number) => {
    if (window.confirm(DELETE_WARNING)) {
      ApiService.dataCenterFiles.delete(id).then(() => {
        props.onDelete();
        listContext.loadList?.();
        dispatch(setAppToast(newToast("success")));
      });
    }
  };

  const menuItems: MenuItemType[] = [];
  if (props.id > 0) {
    if (props.canDelete)
      menuItems.push({
        label: <Typography color="error">Delete</Typography>,
        action: () => postDelete(props.id),
      });
  }

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center">
        <Typography variant="inherit">Data Center File ({props.id})</Typography>
        {menuItems.length > 0 && <DropDownMenu menuItems={menuItems} />}
      </Stack>

      <Stack direction="row" alignItems="center">
        <CloseButton />
      </Stack>
    </Stack>
  );
};
